module.exports = __webpack_public_path__ + "img/success-subscribe.3913baba.svg";